import { Hero } from "@/components/Hero";
import { ChristmasTopBar } from "@/components/ChristmasTopBar";
import { StartHere } from "@/components/StartHere";
import { MonthTeaser } from "@/components/MonthTeaser";
import { Manifesto } from "@/components/Manifesto";
import { PlannerTeaser } from "@/components/PlannerTeaser";
import { GetYourGuide, GygTivoliCard, GygCity } from "@/components/GetYourGuide";
import { ChristmasBanner } from "@/components/ChristmasBanner";
import { HomeTextAd } from "@/components/HomeTextAd";
import { FeaturedPartners } from "@/components/FeaturedPartners";
import { Faq } from "@/components/Faq";
import { Seo, PageSchema } from "@/components/Seo";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Seo
        title="CPH Highlights — Copenhagen Travel Guide & Itinerary Planner"
        description="The local Copenhagen guide with a free itinerary planner — what to see, where to stay, what to eat, transport, seasons, Christmas and easy day trips."
        path="/"
        preloadImage="https://customer-assets-cm19k8pv.emergentagent.net/job_explore-copenhagen/artifacts/6ebajbre_Nyhavn.webp"
      />
      <PageSchema
        name="Copenhagen Travel Guide & Free Itinerary Planner"
        description="The local Copenhagen guide with a free itinerary planner — what to see, where to stay, what to eat, transport, seasons, Christmas and easy day trips."
        path="/"
      />
      <div className="h-16 md:h-20" aria-hidden="true" />
      <ChristmasTopBar />
      <Hero />
      <StartHere />
      <ChristmasBanner />
      <MonthTeaser />
      <Manifesto />
      <GetYourGuide />
      <PlannerTeaser />
      <HomeTextAd />
      <FeaturedPartners />
      {/* compact self-made Tivoli ticket ad ahead of the FAQ */}
      <section className="bg-white border-t border-dotted border-zinc-300">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-10 md:py-14 flex justify-center">
          <div className="w-full max-w-md">
            <GygTivoliCard testid="home-tivoli-ticket-pre-faq" />
          </div>
        </div>
      </section>
      <Faq />
      {/* full GYG city widget after the FAQ, before the footer */}
      <section data-testid="home-gyg-city" className="bg-[#F9F8F6] border-t border-dotted border-zinc-300">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-10 md:py-14">
          <GygCity />
        </div>
      </section>
    </main>
  );
}
